<template>
  <div class="layout" :class="{ 'is-mobile': $isMobile }">
    <img src="../../assets/mobile/home-top-bg.png" class="img-bg" v-if="isMobile && this.$route.name === 'index' " />
    <app-header-mobile v-if="isMobile"></app-header-mobile>
    <app-header v-else></app-header>

    <div class="layout-content" >
      <router-view></router-view>
    </div>
    <app-footer v-if="!$route.meta.hideFooter"></app-footer>
  </div>
</template>

<script>
import appHeaderMobile from "./header-mobile.vue";
import appHeader from "./header.vue";
import appFooter from "./footer.vue";

export default {
  data() {
    return {
      isMobile: this.detectMobile(),
    };
  },
  components: {
    appHeaderMobile,
    appHeader,
    appFooter,
  },
  methods: {
  /**
   * 检测当前设备是否为移动设备
   * 通过检查用户代理字符串和屏幕宽度来判断
   */
    detectMobile() {
      const { userAgent } = navigator;
      const mobileKeywords = ["Mobi", "Android", "iPhone", "iPad", "iPod", "Windows Phone"];
      console.log(
        "obileKeywords2.some(keyword => userAgent.includes(keyword))",
        mobileKeywords.some((keyword) => userAgent.includes(keyword))
      );
      if (mobileKeywords.some((keyword) => userAgent.includes(keyword))) {
        return true;
      }

      const screenWidth =
        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const isSmallScreen = screenWidth <= 768;

      return isSmallScreen;
    },
  },
};
</script>

<style lang="less" scoped>
.layout {
  display: flex;
  background: #f7f7f7;
  flex-direction: column;
  margin: 0;
  padding: 0;
  .img-bg{
    position: absolute;
    top: 0;
    height: 22rem;
    width: 100%;
  }

  .layout-content {
    overflow: auto;
    box-sizing: border-box;
    width: 1200px;
    margin: 0 auto;
    background-color: #f7f7f7;
    padding: 22px 0;
    // margin-top: 22px;
    // margin-bottom: 22px;
    min-height: calc(100vh - 188px - 277px);
}

}

.layout.is-mobile {
  .layout-content {
    min-height: calc(100vh - 270px);
    width: 100vw;
    margin-top: 10px;
    margin-bottom: 0;
    margin-bottom: 10px;

  }
} 
</style>
